/**
 * 高德地图坐标转GPS坐标算法
 */

//定义一些常量
const PI = 3.1415926535897932384626;
const a = 6378245.0;  //长半轴
const ee = 0.00669342162296594323; //扁率

/**
 * GCJ02 转换为 WGS84
 * @param lng
 * @param lat
 * @returns {*[]}
 */
export function gcj02towgs84(lng, lat) {
    lat = +lat
    lng = +lng
    if (out_of_china(lng, lat)) {
        return [lng, lat]
    } else {
        let dlat = transformlat(lng - 105.0, lat - 35.0)
        let dlng = transformlng(lng - 105.0, lat - 35.0)
        let radlat = lat / 180.0 * PI
        let magic = Math.sin(radlat)
        magic = 1 - ee * magic * magic
        let sqrtmagic = Math.sqrt(magic)
        dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI)
        dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI)
        let mglat = lat + dlat
        let mglng = lng + dlng
        return [lng * 2 - mglng, lat * 2 - mglat]
    }
}

/**
 * WGS84 转换为 GCJ02
 * @param lng
 * @param lat
 * @returns {*[]}
 */
export function wgs84togcj02(lng, lat) {
    lat = +lat
    lng = +lng
    if (out_of_china(lng, lat)) {
        return [lng, lat]
    } else {
        let dlat = transformlat(lng - 105.0, lat - 35.0)
        let dlng = transformlng(lng - 105.0, lat - 35.0)
        let radlat = lat / 180.0 * PI
        let magic = Math.sin(radlat)
        magic = 1 - ee * magic * magic
        let sqrtmagic = Math.sqrt(magic)
        dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI)
        dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI)
        return [lng + dlng, lat + dlat]
    }
}

/**
 * 判断是否在国内，不在国内则不做偏移
 * @param lng
 * @param lat
 * @returns {boolean}
 */
function out_of_china(lng, lat) {
    lat = +lat
    lng = +lng
    // 纬度3.86~53.55,经度73.66~135.05
    return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55)
}

function transformlat(lng, lat) {
    lat = +lat
    lng = +lng
    let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng))
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0
    ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0
    ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0
    return ret
}

function transformlng(lng, lat) {
    lat = +lat
    lng = +lng
    let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0
    ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0
    ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0
    return ret
}

/**
 * listMap结构转为list结构
 * @map [{lon,lat},{}]
 * @keys ['lon','lat'] 要转为列表类型的键
 * @dealValFn 对值做处理的函数
 * @returns [[1,2],[2,3],[4,5]]
*/
export function listMap2list(listMap, keys, dealValFn) {
  let _fn = dealValFn;
  if (!_fn) {
    _fn = (s) => s;
  }

  const len = listMap.length;
  let _2arr = [];
  for (let i = 0, temp; i < len; i++){
    temp = listMap[i];
    var _point = [];
    // 一个点处理
    keys.forEach(k => {
      _point.push(_fn(temp[k]));
    });

    _2arr.push(_point);
  }
  return _2arr;
}
/**区域冲突检测（已移除高德地图依赖）
 * @area1 {type:'',area:[[],[]]}
*/
export function collisionValid(area1, area2) {
  console.warn('[APP WARNING] collisionValid: 高德地图功能已移除，返回false');
  return false;
}

/**从列表中查找某一项
 * @param arr:目标列表[{},{}]; value:要查找的值; valueKey:值使用的key名;
 * @returns [{},索引] 索引不为-1时表示查找成功。
 * 使用示例：
 * const [item,ix] = getItem([{a:1},{a:2}],1,'a'); // item={a:1}, ix=0
*/
export function getItem(arr,value, valueKey) {
  if (!(arr instanceof Array)) throw new Error('[APP ERROR] getItem: 参数1需要Array类型');
  if (!valueKey) throw new Error('[APP ERROR] getItem: 需要第3个参数');

  const len = arr.length;
  let item = null;
  let ix = -1;

  for (let i = 0; i < len; i++) {
    if (arr[i][valueKey] === value) {
      item = arr[i];
      ix = i;
      break;
    }
  }
  if (item === null) console.info('[APP INFO] getItem: 未找到' + value);

  return [item, ix];
}


/**
 * @desc 深拷贝,对原型链上的属性不会进行拷
 * @param { object } data 目标数据
 * @return { object } 拷贝的对象
*/
export function deepCopy(data) {
  // null, string, number, undefined, function, bool情况
  if (typeof data !== 'object' || !data) return data;

  let _copyData = null;
  if (Array.isArray(data)) {
    // 列表结构
    _copyData = [];
    const len = data.length;
    for (let i = 0; i < len; i++) {
      _copyData.push(deepCopy(data[i]));
    }
  } else {
    // map结构
    _copyData = {};
    const keyList = Object.keys(data);
    const len2 = keyList.length;
    for (let i = 0, key; i < len2; i++) {
      key = keyList[i];
      _copyData[key] = deepCopy(data[key]);
    }
  }

  return _copyData;
}

function dot(v1,v2){
  return v1.x*v2.x + v1.y*v2.y;
}
function clamp(val,min,max){
  return Math.min(Math.max(val,min),max);
}
function length(v){
  return Math.sqrt(dot(v,v));
}
/**线段的 2D SDF
 * @param {{x:Number,y:Number}} p 判断的点
 * @param {{x:Number,y:Number}} a 线段的一端
 * @param {{x:Number,y:Number}} b 线段的一端
*/
function sdSegment(p,a,b){
  var pa = {x:p.x-a.x, y:p.y-a.y}, ba = {x:b.x-a.x, y:b.y-a.y};
  var h = clamp( dot(pa,ba)/dot(ba,ba), 0.0, 1.0 );
  ba.x = ba.x*h;
  ba.y = ba.y*h;

  return length( {x:pa.x-ba.x,y:pa.y-ba.y} );
}
/***判断两个线段是否相交
 * L1：(x1,y1)  (x2,y2)
 * L2：(x3,y3)  (x4,y4)
*/
export function isCross(x1, y1, x2, y2, x3, y3, x4, y4) {
  const term1 = Math.min(x1, x2) <= Math.max(x3, x4);
  const term2 = Math.min(y3, y4) <= Math.max(y1, y2);
  const term3 = Math.min(x3, x4) <= Math.max(x1, x2);
  const term4 = Math.min(y1, y2) <= Math.max(y3, y4);
  const expression = 0.00000000000000001;
  // 两线矩形区域不相交时返回false
  if (!(term1 && term2 && term3 && term4)) return false;
  
  const p1sdf = sdSegment({ x: x1, y: y1 }, { x: x3, y: y3 }, { x: x4, y: y4 });
  const p2sdf = sdSegment({ x: x2, y: y2 }, { x: x3, y: y3 }, { x: x4, y: y4 });
  const p3sdf = sdSegment({ x: x3, y: y3 }, { x: x1, y: y1 }, { x: x2, y: y2 });
  const p4sdf = sdSegment({ x: x4, y: y4 }, { x: x1, y: y1 }, { x: x2, y: y2 });
  // 各端点离对方线段最短距离
  if(Math.min(p1sdf,p2sdf,p3sdf,p4sdf) < 0.000006) return false;

  var u, v, w, z;
  u = (x3 - x1) * (y2 - y1) - (x2 - x1) * (y3 - y1);
  v = (x4 - x1) * (y2 - y1) - (x2 - x1) * (y4 - y1);
  w = (x1 - x3) * (y4 - y3) - (x4 - x3) * (y1 - y3);
  z = (x2 - x3) * (y4 - y3) - (x4 - x3) * (y2 - y3);
  return (u * v <= expression && w * z <= expression);
}
/***引射线法判断1个点是否在一个平面内
 * @param {*} point {x:1,y:2}   
 * @param {Array} polygon [{x:11,y:23},{x:34,y:45},...]
*/
export function isPointInPolygon(point, polygon) {
  var N = polygon.length;
  var boundOrVertex = true; //如果点位于多边形的顶点或边上，也算做点在多边形内，直接返回true
  var intersectCount = 0; //cross points count of x 
  var precision = 2e-10; //浮点类型计算时候与0比较时候的容差
  var p1, p2; //neighbour bound vertices
  var p = point; //测试点

  p1 = polygon[0]; //left vertex        
  for (var i = 1; i <= N; ++i) { //check all rays            
    if (p.x == p1.x && p.y == p1.y) {
      return boundOrVertex; //p is an vertex
    }

    p2 = polygon[i % N]; //right vertex            
    if (p.y < Math.min(p1.y, p2.y) || p.y > Math.max(p1.y, p2.y)) {         
      p1 = p2;
      continue; //next ray left point
    }

    if (p.y > Math.min(p1.y, p2.y) && p.y < Math.max(p1.y, p2.y)) {
      if (p.x <= Math.max(p1.x, p2.x)) {                 
        if (p1.y == p2.y && p.x >= Math.min(p1.x, p2.x)) {
          return boundOrVertex;
        }

        if (p1.x == p2.x) {              
          if (p1.x == p.x) {
            return boundOrVertex;
          } else { //before ray
            ++intersectCount;
          }
        } else {
          var xinters = (p.y - p1.y) * (p2.x - p1.x) / (p2.y - p1.y) + p1.x; //cross point of x                        
          if (Math.abs(p.x - xinters) < precision) {
            return boundOrVertex;
          }

          if (p.x < xinters) {
            ++intersectCount;
          }
        }
      }
    } else {
      if (p.y == p2.y && p.x <= p2.x) {              
        var p3 = polygon[(i + 1) % N]; //next vertex                    
        if (p.y >= Math.min(p1.y, p3.y) && p.y <= Math.max(p1.y, p3.y)) {
          ++intersectCount;
        } else {
          intersectCount += 2;
        }
      }
    }
    p1 = p2; //next ray left point
  }

  if (intersectCount % 2 == 0) {
  //偶数在多边形外
    return false;
  } else {
    //奇数在多边形内
    return true;
  }
}

/*****检测两个多边形区域是否冲突
 * @param {Array} polygon1 [{ x: 10, y: 10 }]
 * @param {Array} polygon2 [{x,y}]
*/
export function isCollision(polygon1,polygon2) {
  const len1 = polygon1.length;
  const len2 = polygon2.length;
  let exitCollis = false;
  let _i, _j;

  for (let i = 0; i < len1; i++) {
    _i = (i+1) % len1;
    if (exitCollis) break;
    for (let j = 0; j < len2; j++) {
      _j = (j+1) % len2;
      exitCollis = isCross(polygon1[i].x, polygon1[i].y, polygon1[_i].x, polygon1[_i].y,
        polygon2[j].x, polygon2[j].y, polygon2[_j].x, polygon2[_j].y);

      if (exitCollis) break;
    }
  }
  
  if (exitCollis) return true;
  // 判断多边形1 是否在 多边形2 中
  for (let k = 0; k < len1; k++){
    exitCollis = isPointInPolygon(polygon1[k], polygon2);
    if (!exitCollis) break;
  }

  if (exitCollis) return true;
  // 判断多边形2 是否在 多边形1 中
  for (let k = 0; k < len2; k++){
    exitCollis = isPointInPolygon(polygon2[k], polygon1);
    if (!exitCollis) break;
  }

  return exitCollis;
}